import { SKU_OPTIONS, SKU_370_ENABLED_LOCATIONS } from '@/constants';

export const getFilteredSkuOptions = (locationId: string) => {
  const isFilteredLocation = SKU_370_ENABLED_LOCATIONS.map(
    (location) => location.locationId,
  ).includes(locationId);

  return SKU_OPTIONS.filter((sku) => (isFilteredLocation ? sku.id !== 200 : sku.id !== 370));
};
